import type { PublisherAction, PublisherStatus } from '@planuze/admin-contracts';

/* Mapa data-driven status→tom/label do publisher (ADR-0471/0476). Fonte única reusada pela
   tabela do painel e pela página de detalhe — sem duplicar o `if (status === ...)` (§4.18).
   O mapa ação→status alvo vive em `@planuze/admin-contracts` (`publisherActionToStatus`), fonte
   única compartilhada com o admin-service.

   `statusLabel` aceita `labels` OPCIONAL (default pt-BR) em vez de um `Bilingual<T>`/
   `useBilingual`, porque esta função também é chamada por `routes/publisher-detail-page.tsx` —
   fora do escopo desta migração (ADR-0811 cobre só
   `components/{plans,support,pack-submissions,publishers}/`) — que já injeta o próprio
   `statusLabels` bilíngue (`content/sections/publisher-detail.ts`). Os consumidores desta
   migração (`publishers-table.tsx`, `pack-submissions/publisher-link.tsx`) passam o mesmo tipo
   vindo do hook da área. */

type PublisherTone = 'success' | 'warning' | 'destructive' | 'neutral';

/* Verbo pt-BR de cada ação (mensagens de confirmação/toast) — só consumido por
   `routes/publisher-detail-page.tsx` e `routes/publishers-list-page.tsx` (fora do escopo desta
   migração), então permanece fixo em pt-BR. */
export const ACTION_VERB: Record<PublisherAction, string> = {
  verify: 'verificar',
  suspend: 'suspender',
  unsuspend: 'reativar',
  ban: 'banir',
  unban: 'desbanir',
};

export function statusTone(status: PublisherStatus): PublisherTone {
  if (status === 'verified') return 'success';
  if (status === 'banned') return 'destructive';
  if (status === 'suspended') return 'neutral'; // reversível → atenção, não terminal
  return 'warning'; // pending
}

export interface PublisherStatusLabels {
  readonly verified: string;
  readonly banned: string;
  readonly suspended: string;
  readonly pending: string;
}

const DEFAULT_STATUS_LABELS: PublisherStatusLabels = {
  verified: 'Verificado',
  banned: 'Banido',
  suspended: 'Suspenso',
  pending: 'Pendente',
};

export function statusLabel(
  status: PublisherStatus,
  labels: PublisherStatusLabels = DEFAULT_STATUS_LABELS,
): string {
  if (status === 'verified') return labels.verified;
  if (status === 'banned') return labels.banned;
  if (status === 'suspended') return labels.suspended;
  return labels.pending;
}
